/**
 * select-groups-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { Observable } from "rxjs/Rx";

import { Group } from "../auth/identity/group";
import { CustomValidators } from "../support/validators";

export interface GroupSelectionContext extends BSModalContext
{
  availableGroups : Group[];
  initialSelection : number[];
}

/**
 * {@link SelectGroupsModalComponent} creates a dialog for choosing a subset of
 * a user's groups to be applied to a newly-created subject context. This dialog
 * automatically appears when a user with multiple groups attempts to start a
 * new intake (see {@link SubjectCreatorGuard}).
 */
@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      New Subject Visibility
    </h4>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Select groups for the new entry:</label>
      <select
        class="form-control"
        [formControl]="selectedGroups"
        [size]="availableGroups.length"
        multiple>
        <option
          *ngFor="let group of availableGroups"
          [ngValue]="group.id">
          {{group.name}}
        </option>
      </select>

    </div>
    <p>
      Groups determine who will be able to see, search, and modify this record.
    </p>
    <p>
      You can select multiple groups by dragging or by holding <kbd>CTRL</kbd>
      or <kbd>CMD</kbd> and clicking. You must select at least one group for
      this subject.
    </p>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      (click)="submit()"
      [disabled]="selectedGroups.invalid">
      Create Subject
    </button>
  </div>
  `
})
export class SelectGroupsModalComponent
  implements ModalComponent<GroupSelectionContext>, OnInit
{
  /**
   * Form control for the selector box that presents group options.
   */
  public selectedGroups : FormControl;

  /**
   * The list of groups available. This is provided by the GroupSelectionContext
   * and sourced from the groups available to Self on the UserService.
   */
  public availableGroups : Group[];

  constructor (
    public dialog : DialogRef<GroupSelectionContext>,
  ) {}

  public ngOnInit () : void
  {
    this.availableGroups = this.dialog.context.availableGroups;
    this.selectedGroups = new FormControl(
      this.dialog.context.initialSelection || [],
      [Validators.required, CustomValidators.arrayMin(1)]
    );
  }

  /**
   * Validate the selection, then close the dialog and return the groups.
   */
  public submit () : void
  {
    if (!this.selectedGroups.valid)
    {
      console.warn("Encountered errors:", this.selectedGroups.errors);
      return;
    }

    this.dialog.close(this.selectedGroups.value);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/subjects/select-groups-modal.component.ts